import styled from "styled-components";

export const CardHeading = styled.h2`
  display: inline-block;
  font-size: 1.5rem;
  margin-bottom: 0;
`;

export const Divider = styled.span`
  margin: 0 3px;
`;
